import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    recordingMixId: Number
  }

  connect() {
  }

  add(event) {
    event.preventDefault()
    event.stopPropagation()

    const albumSidebar = document.getElementById('album_sidebar')

    if (!albumSidebar) {
      console.error("No album sidebar found")
      alert("No album in sidebar")
      return
    }

    const albumId = albumSidebar.dataset.albumId

    if (!albumId) {
      alert("No album in sidebar")
      return
    }

    // Create form data
    const formData = new FormData()
    formData.append('album_track[recording_mix_id]', this.recordingMixIdValue)
    formData.append('sidebar', 'true')

    // Make POST request using Turbo
    fetch(`/admin/albums/${albumId}/album_tracks`, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.text())
    .then(html => {
      // Turbo will automatically process the turbo-stream response
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Error adding track to album')
    })
  }
}
